import { render } from "./senaraiCukaiTable.vue?vue&type=template&id=73ba6cb6"
import script from "./senaraiCukaiTable.vue?vue&type=script&lang=js"
export * from "./senaraiCukaiTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__